
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.167 5.5V1.333a.833.833 0 00-1.667 0V5.5H1.333a.833.833 0 000 1.667H5.5v4.166a.833.833 0 001.667 0V7.167h4.166a.833.833 0 000-1.667H7.167z"}})])
          )
        }
      }
    